<template>
  <div class="main">
    <layout />
    <TopbgVue :title="title" />
    <div class="list">
      <div class="item-title">{{ title }}</div>
      <div class="ul">
        <div @click="toDetail(item)" class="li" v-for="(item, index) in listData" :key="index">
          <div class="li-title">{{ item.title }}</div>
          <div class="li-text">{{ item.time }}</div>
          <div class="li-text">
            {{ item.text }}
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import TopbgVue from "./Topbg.vue";
import Footer from './footer.vue';
import Layout from './Layout.vue';
export default {
  data() {
    name:'Houserental'
    return {
      title: "房屋出租",
      listData:[{
        title:'单间一房一厅配套出租',
        time:'24-01-01',
        text:'家具配套齐全，房子靠近路边交通方便采光好，附近有地​‌‌铁，公交站台，菜市场超市等等，欢迎随时都可以过来过来看房子，联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌‌'
      },{
        title:'86平 84万 南北通透',
        time:'24-01-01',
        text:'房子精装修拎包入住随时看房​‌‌装修情况：精装修联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌'
      },{
        title:'电梯精装现房 金砖茶城',
        time:'24-01-02',
        text:'南宁各区域好房源，欢迎进入我的店铺查看，欢迎随时电​‌‌话咨询，相信我的专业，为您置业安家保驾护航。1、小区是成熟小区，入住率高，周边环境配套成熟，地铁口，出行十分方便。2、是电梯小高层，中高楼层，视野非常好。3、学校就在旁边，可落户读书。4、本小区属于政府正规70年产权，城镇住宅性质。。5、来电享受额外优惠。本人全南宁小区都有，随时约。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'双南北2房，中间楼层，中间位置，南北通全明，采光好',
        time:'24-01-03',
        text:'核心卖点此南北通透中间楼层采光好交通方便近南宁火车站。小区介绍小区近商场近香炉礁商圈近南宁火车站近北京街商圈交通方便购物方便。户型介绍南北通透南卧室中间是客厅还有一个北卧室北厨房采光足。售房详情业主改善换房业主看房方便手续清晰交通方便出行方便。。。。联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌​‌‌​‌‌​‌‌'
      },{
        title:'封闭小区 低楼层 南北通透 采光好',
        time:'24-01-04',
        text:'核心卖点悦泰福里封闭小区低楼层南北通透采光好拎包入住适宜人群小区环境优美品质高保安24小时值守有电梯地角好楼下还有健身器材。地下停车场。周边配套300米大菜市楼下邮政银行悦泰实验分校，500米凯旋广场晚饭后可以带家人遛弯青泥洼商圈权属抵押此房产权明晰，8月23日满两年。人车分流适合婴幼儿中年和老年人居住，交通出行小区北面是双兴街车站，有40.541等，南面东关街桥洞走过去是411，走到北岗桥车就多了，步行大概900米联系我时，请说是在河北蝌蚪电子科技有限公司看到的，谢谢！​‌‌​‌‌‌'
      }]
    };
  },
  components: {
    TopbgVue,
    Layout,
    Footer
  },
  mounted() {
  },
  methods: {
    toDetail(item) {
      this.$router.push({
        path:'/detail',
        query: {
          title: item.title,
          text: item.time,
          detail: item.text,
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
.list {
  max-width: 1320px;
  margin: 80px auto 0;
  .item-title {
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #0099cc;
  }
  .ul {
    padding: 0 30px 50px 200px;
    background: #f0f8ff;
    .li {
      padding-top: 50px;
      .li-title {
        cursor: pointer;
        font-size: 16px;
        font-weight: bold;
        color: #000000;
      }
      .li-text {
        padding-top: 10px;
        font-size: 16px;
        color: #717275;
      }
      .li-text:nth-child(2) {
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2; /*省略几行写几*/
        -webkit-box-orient: vertical;
      }
    }
  }


}
</style>